module.exports = __webpack_public_path__ + "img/im-on-it-card-header-text.9faefdb1.svg";